<template>
    <div class="root">
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
            <v-subheader class="pl-0 title">
                {{$vuetify.t('$vuetify.login.title')}}
            </v-subheader>

            <v-text-field
                ref="username"
                v-model="username"
                autocorrect="off" autocapitalize="none"
                :label="$vuetify.t('$vuetify.login.username')"
                required
            ></v-text-field>

            <v-text-field
                type="password"
                v-model="password"
                :label="$vuetify.t('$vuetify.login.password')"
                required
            ></v-text-field>

            <v-btn
                :disabled="!valid"
                color="success"
                @click="validate"
            >
                {{$vuetify.t('$vuetify.login.login')}}
            </v-btn>
        </v-form>

        <v-snackbar v-model="loginError" color="error">
            {{ loginErrorMessage }}
        </v-snackbar>
    </div>
</template>

<script>
    export default {
        name: 'login',

        data: () => ({
            sending: false,
            valid: false,
            username: '',
            password: '',
            loginError: '',
            loginErrorMessage: ''
        }),

        components: {
        },

        mounted () {
            this.$refs.username.focus()
        },

        methods: {
            validate () {
                if (this.$refs.form.validate()) {
                    this.$store.dispatch('loginUser', {
                        username: this.username,
                        password: this.password
                    })
                        .then((result) => {
                            if (result && result.ok) {
                                this.$router.push({name:'events'})
                            } else {
                                this.loginError = true
                                this.loginErrorMessage = result.message
                            }
                        })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>
